<div class="filter-wrapper">
  <span
    (click)="showFilterPopup()"
    class="filter-input"
  >{{currentValue}}</span>
  <i class="sch-caret-down" id="set-filter-icon" (click)="showFilterPopup()"></i>
</div>